import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Button,
  Avatar
} from '@mui/material';
import CallIcon from '@mui/icons-material/Call';
import CallEndIcon from '@mui/icons-material/CallEnd';
import { MSN } from './msnTheme';

export default function IncomingCallModal({ open, fromUser, onAccept, onReject }) {
  const statusColor = MSN.statusBorder?.available || MSN.online;
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: 'rgba(15,23,42,0.98)',
          border: '1px solid rgba(148,163,184,0.2)',
          borderRadius: 3
        }
      }}
    >
      <DialogTitle sx={{ color: '#e2e8f0', textAlign: 'center' }}>
        Chamada recebida
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 2 }}>
          <Box
            sx={{
              display: 'inline-block',
              borderRadius: 2,
              border: `3px solid ${statusColor}`,
              p: 0.25,
              overflow: 'hidden',
            }}
          >
            <Avatar
              sx={{
                width: 72,
                height: 72,
                bgcolor: 'rgba(129,140,248,0.4)',
                color: '#c7d2fe',
                fontSize: '1.5rem'
              }}
            >
              {(fromUser?.nome || '?').charAt(0).toUpperCase()}
            </Avatar>
          </Box>
          <Typography variant="h6" sx={{ color: '#e2e8f0' }}>
            {fromUser?.nome || fromUser?.email || 'Contato'}
          </Typography>
          <Typography variant="body2" sx={{ color: 'rgba(148,163,184,0.9)' }}>
            deseja iniciar uma chamada de vídeo
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <Button
              variant="contained"
              color="error"
              startIcon={<CallEndIcon />}
              onClick={onReject}
              sx={{ bgcolor: 'rgba(239,68,68,0.8)', '&:hover': { bgcolor: 'rgba(239,68,68,0.9)' } }}
            >
              Recusar
            </Button>
            <Button
              variant="contained"
              color="success"
              startIcon={<CallIcon />}
              onClick={onAccept}
              sx={{ bgcolor: 'rgba(34,197,94,0.8)', '&:hover': { bgcolor: 'rgba(34,197,94,0.9)' } }}
            >
              Atender
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
